// Heals cookies already written in the broken `%221%22` (JSON-quoted `"1"`) format
// by an earlier build (see CONSENT_COOKIE_OPTS in useCookieConsent.ts for the root
// cause). Must run before anything reads these cookies via useCookie, so it talks
// to document.cookie directly and is registered with enforce: 'pre'.
const CONSENT_COOKIE_NAMES = ['cookie_accepted', 'functional_cookies', 'statistic_cookies', 'marketing_cookies']
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 1 year

export default defineNuxtPlugin({
  name: 'repair-consent-cookies',
  enforce: 'pre',
  setup() {
    for (const name of CONSENT_COOKIE_NAMES) {
      const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
      if (!match) continue

      const raw = decodeURIComponent(match[1] ?? '')
      if (raw !== '"1"' && raw !== '"0"') continue

      const fixed = raw.slice(1, -1)
      document.cookie = `${name}=${encodeURIComponent(fixed)}; path=/; max-age=${COOKIE_MAX_AGE}`
    }
  },
})
